// extracted by mini-css-extract-plugin
export default {"particles":"NoirParticles_particles__WKa6U","dust":"NoirParticles_dust__chwA+","noir-drift":"NoirParticles_noir-drift__bQpAX"};